<div *ngIf="!isEditable() else editable">
	<span *ngIf="this.shouldHasLink() else noLink">
		<a class="link" *ngIf="this.isGidColumn() || this.isGroupIdColumn()"
           (click)="germplasmDetailsPopupService.open(this.rowData)"><truncate-span [textInput]="this.rowData"></truncate-span></a>

		<a class="link" *ngIf="this.isDesignationColumn()"
           (click)="germplasmDetailsPopupService.open(this.getGidData())"><truncate-span [textInput]="this.rowData" [maxLength]="MAX_NAME_DISPLAY_SIZE"></truncate-span></a>

		<a *ngIf="this.isLotsColumn()"
		   (click)="$event.stopPropagation(); inventoryDetailsPopupService.open(this.getGidData())">{{this.rowData}}</a>
		<span *ngIf="this.isLotsColumn() && this.rowData === '0'">-</span>

		<a *ngIf="this.isLocationNameColumn()"
		   (click)="$event.stopPropagation()"
		   [routerLink]="['/', { outlets: { popup: 'location/' + this.getLocationIdData() } }]"
		   queryParamsHandling="merge">{{this.rowData}}</a>

		<a *ngIf="this.isBreedingMethodNameColumn()"
		   (click)="$event.stopPropagation()"
		   [routerLink]="['/', { outlets: { popup: 'breeding-method/' + this.getBreedingMethodIdData() } }]"
		   queryParamsHandling="merge">{{this.rowData}}</a>

    	<a *ngIf="this.isFemaleParentGidColumn() || this.isMaleParentGidColumn()">
            <span *ngIf="!this.rowData || this.rowData.length === 0"> - </span>
            <span *ngIf="this.rowData">
                <jhi-expandable-cell [data]="rowData" [asLink]="true" (itemClick)="germplasmDetailsPopupService.open(rowData[$event])"></jhi-expandable-cell>
            </span>
        </a>

        <a *ngIf="this.isFemaleParentNameColumn()">
            <span *ngIf="!this.rowData || this.rowData.length === 0"> - </span>
            <span *ngIf="this.rowData">
                <jhi-expandable-cell [data]="rowData" [asLink]="true" (itemClick)="germplasmDetailsPopupService.open(this.getFemaleGIdsData($event))"></jhi-expandable-cell>
            </span>
        </a>

        <a *ngIf="this.isMaleParentNameColumn()">
            <span *ngIf="!this.rowData || this.rowData.length === 0"> - </span>
            <span *ngIf="this.rowData">
                 <jhi-expandable-cell [data]="rowData" [asLink]="true" (itemClick)="germplasmDetailsPopupService.open(this.getMaleGIdsData($event))"></jhi-expandable-cell>
            </span>
        </a>
	</span>
	<ng-template #noLink>
		<span *ngIf="this.isGroupIdColumn() || this.isLotsColumn()">-</span>
		<span *ngIf="!this.isGroupIdColumn() && !this.isLotsColumn()
		&& !this.isNamesColumn()
		&& !this.isCrossColumn()
		&& !this.isImmediateSourceNameColumn()
		&& !this.isGroupSourceNameColumn()
		&& !this.isFemaleParentNameColumn()
		&& !this.isMaleParentNameColumn()"><truncate-span [textInput]="this.rowData" [maxLength]="MAX_NAME_DISPLAY_SIZE" [minWidth]="'280px'"></truncate-span></span>
		<span *ngIf="this.isNamesColumn()
		|| this.isCrossColumn()
		|| this.isImmediateSourceNameColumn()
		|| this.isGroupSourceNameColumn() "><truncate-span [textInput]="this.rowData" [maxLength]="MAX_NAME_DISPLAY_SIZE" [minWidth]="'280px'"></truncate-span></span>
	</ng-template>
</div>
<ng-template #editable>
	<div *ngIf="!isEditing() || germplasmList?.locked else editing"
		 (click)="!germplasmList?.locked && edit()"
		 [class.editable]="!germplasmList?.locked">
		<span><!-- filler -->&nbsp;</span>
		{{this.rowData}}
	</div>
</ng-template>
<ng-template #editing>
	<jhi-inline-editor [observationVariable]="column"
					   [value]="this.rowData"
					   (onApply)="submit($event)"
					   (onCancel)="cancel()"
	></jhi-inline-editor>
</ng-template>
